import React from "react";
import { s3baseUri } from "../../../config/config";
import { noImagePlaceholder } from "../../../assets";
import { Chip } from "@mui/material";

const ClientHoverImageCard = ({
  client,
  handleNavigateDetails = () => {},
  width = "100%",
  height = "100%",
  showAdditionalButton = false,
  additionButton = null,
  chipValue = null,
  chipColor = "info",
}) => {
  return (
    <div
      className="pinterest-design tw-card client-img-card"
      style={{ width, height }}
      onClick={() => handleNavigateDetails(client)}
    >
      <img
        src={
          client?.profile_image?.thumbnail_2
            ? s3baseUri + client?.profile_image?.thumbnail_2
            : s3baseUri + client?.profile_image?.thumbnail_1
        }
        alt={client.company_name}
        onError={(e) => {
          e.target.src = noImagePlaceholder;
        }}
      />
      <div className="client-img-card__overlay" />
      <div className="client-img-card__caption">
        <h6 className="">{client.company_name}</h6>
        {showAdditionalButton && additionButton}
      </div>

      {chipValue && (
        <Chip
          label={chipValue}
          variant="contained"
          className={`text-white text-capitalize`}
          color={chipColor}
          size="small"
          sx={{
            position: "absolute",
            zIndex: 1000,
            top: "5px",
            right: "5px",
            "& .MuiChip-label": {
              color: "var(--text-white) !important",
              lineHeight: "1.2",
            },
          }}
        />
      )}
    </div>
  );
};

export default ClientHoverImageCard;
